import {Component, inject, Input, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {CartService} from '../services/cart';
import {PaypalService} from '../services/paypal-service';
import {Router} from '@angular/router';
import {FormGroup} from '@angular/forms';
declare let paypal: any;
@Component({
  selector: 'app-paypal-growth-button',
  imports: [],
  templateUrl: './paypal-growth-button.html',
  styleUrl: './paypal-growth-button.scss'
})
export class PaypalGrowthButton implements OnInit {
  cartService = inject(CartService)
  private planId = environment.growthPlanId;
  // @Input() formGroup!: FormGroup;
  private paypalService = inject(PaypalService)
  private router = inject(Router)

  @Input() formGroup!: FormGroup;
  private paypalButtonsRendered = false;

  private hasValidBilling(values: any): boolean {
    // Check required billing fields here
    return values?.email && values?.fullName;
  }

  ngOnInit(): void {

    if (!this.formGroup) return;

    // Subscribe to form status changes
    this.formGroup.statusChanges.subscribe(status => {
      if (status === 'VALID' && !this.paypalButtonsRendered) {
        const billing = this.formGroup.getRawValue();
        this.renderPaypalButtons()
          .catch(err => console.error('PayPal render error:', err));
      }
    });

    // Also check initial status
    if (this.formGroup.valid && !this.paypalButtonsRendered) {
      const billing = this.formGroup.getRawValue();
      this.renderPaypalButtons()
        .catch(err => console.error('Initial PayPal render error:', err));
    }
  }

  private async renderPaypalButtons() {
    const cart = this.cartService.getItems();
    const billing = this.formGroup.getRawValue();
    const planId = this.planId;

    console.log({ cart, billing });

    try {
      await this.paypalService.loadPaypalSdk();
      this.paypalButtonsRendered = true;

      paypal.Buttons({
        style: {
          shape: 'pill',
          color: 'gold',
          layout: 'vertical',
          label: 'subscribe'
        },
        createSubscription: function (data: any, actions: any) {
          return actions.subscription.create({
            plan_id: planId
          });
        },
        onApprove: async (data: any, actions: any) => {
          const subscriptionId = data.subscriptionID;
          // alert(`Subscription ID: ${subscriptionId}`);

          // 🔁 Send to your FastAPI backend
          const res = await fetch(`${environment.apiBaseUrl}/paypal/confirm-subscription`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ subscription_id: subscriptionId, cart, billing })
          });

          const captureData = await res.json();
          const captured = captureData.capture_response;
          console.log(captured)
          const subscriptionId2 = captured.id;
          const amount = captured.billing_info?.last_payment?.amount?.value || null;
          const payerName = `${captured.subscriber.name.given_name} ${captured.subscriber.name.surname}`;
          const payerEmail = captured.subscriber.email_address;


          if (captured.status === 'ACTIVE') {
            await this.router.navigate(['/checkout/success'], {
              state: { order: { id: subscriptionId2, amount, payerName, payerEmail } }
            });
          } else {
            // failed pagina
            alert('Payment not completed');
          }
          // await this.router.navigate(['/checkout/success'])
        }
      }).render(`#paypal-button-container-growth`); // Renders the PayPal button

    } catch (err) {
      console.error('Failed to load PayPal SDK', err);
    }
  }
}
